import { ENGAGEMENT_REQUEST_TYPE, ENGAGEMENT_TYPE, ENGAGEMENT_BILLING_TYPE } from "@/lib/constants/engagement-codes"
import { EXPENSE_METHODOLOGY } from "@/lib/constants/work-order-codes"
import type { 
  TaskFormData, 
  WorkerFormData, 
  CoreFormData, 
  BillingSetupFormData,
  MilestoneFormData, 
  TimesheetAndExpenseFormData, 
  InvoiceFormData 
} from "@/lib/schemas"

export const getInitialCoreData = (): CoreFormData => ({
  engagementName: '',
  engagementCode: '',
  engagementType: ENGAGEMENT_TYPE.ADVISORY,
  requestType: ENGAGEMENT_REQUEST_TYPE.ORIGINAL,
  selectedClient: 0,
  selectedContact: 0,
  startDate: new Date(),
  endDate: new Date(),
  closedDate: null,
  closedReason: '',
  selectedInternalCompany: 0,
  selectedBranch: '',
  selectedSalesPerson: 0,
  selectedEngagementLead: 0,
  selectedProjectLead: 0,
  selectedClientExecutive: 0,
  selectedOriginalEngagement: 0,
  agreementSignedDate: null,
  isPreEngagement: false,
})

export const getInitialBillingData = (): BillingSetupFormData => ({
  billingType: ENGAGEMENT_BILLING_TYPE.TIME_BASED,
  totalAmount: null,
  totalInternalBudget: null,
  selectedCurrency: '',
  selectedSalesTax: '',
  // null = inherit from the client role; resolved when a client is selected (GW-562)
  chargeSalesTax: null,
})


export const getInitialTimesheetData = (): TimesheetAndExpenseFormData => ({
  selectedTimesheetCycle: '',
  approvers: [],
  selectedApprovalSequence: '',
  expenseMethodologyCode: EXPENSE_METHODOLOGY.NO_EXPENSE,
  expenseApprovers: []
})

export const getInitialInvoiceData = (): InvoiceFormData => ({
  selectedAlternateBill: null,
  selectedBillingFrequency: '',
  selectedPaymentTerms: '',
  selectedInvoiceTemplate: '',
  selectedInvoiceRecipient: 0,
  selectedDeliveryMethod: '',
  includeTimesheet: true,
  invoiceNotes: [],
  ccEmails: []
})

export const getInitialWorkers = (): WorkerFormData[] => []

export const getInitialTasks = (): TaskFormData[] => []

export const getInitialMilestones = (): MilestoneFormData[] => [] 

export const createMilestoneWithDefaults = (
  newId: number, 
  engagementStartDate?: Date | null,
  previousMilestoneEndDate?: Date | null
): MilestoneFormData => {
  let defaultStartDate: Date | null = null
  
  // For the first milestone (id === 1), use engagement start date if available
  if (newId === 1 && engagementStartDate) {
    defaultStartDate = new Date(engagementStartDate)
  }
  // For subsequent milestones, use 1 day after previous milestone end date if available
  else if (newId > 1 && previousMilestoneEndDate) {
    defaultStartDate = new Date(previousMilestoneEndDate)
    defaultStartDate.setDate(defaultStartDate.getDate() + 1)
  }
  
  return {
    id: newId,
    startDate: defaultStartDate,
    endDate: null, // Always blank as per requirements
    status: "NotStarted",
    amount: null,
    internalBudget: null,
    reference: `MS-${newId.toString().padStart(3, '0')}`,
  } as MilestoneFormData
}